<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>

    <template #content>
      <article class="blog-content" lang="de">
        <section class="intro">
          <p>
            Eine virtuelle Tour zu Ihrer WordPress-Website hinzuzufügen ist
            einfacher als Sie denken. Egal ob Immobilienmakler, Hotelbesitzer
            oder Unternehmer – das Einbetten einer interaktiven 360°-Tour dauert
            nur wenige Minuten und erfordert keine Programmierkenntnisse. Hier
            ist die vollständige Schritt-für-Schritt-Anleitung.
          </p>
        </section>

        <section>
          <h2>Methode 1 – Einbetten per iFrame (Empfohlen)</h2>
          <p>
            Diese Methode funktioniert auf jeder WordPress-Seite und erfordert
            kein Plugin. Wenn Sie eine Tour in Travvir veröffentlichen, erhalten
            Sie einen Einbettungscode – ein Standard-HTML-iFrame-Snippet. So
            fügen Sie es in Ihre WordPress-Seite ein:
          </p>
          <p>
            1. Öffnen Sie den WordPress Block-Editor für die Seite, auf der Sie
            die Tour hinzufügen möchten. 2. Fügen Sie einen „Benutzerdefiniertes
            HTML"-Block hinzu. 3. Fügen Sie den Travvir-iFrame-Einbettungscode
            in den Block ein. 4. Zeigen Sie die Seite in der Vorschau an, um zu
            bestätigen, dass die Tour korrekt angezeigt wird. 5. Veröffentlichen
            Sie die Seite.
          </p>
          <p>
            Die iFrame-Einbettung funktioniert mit dem WordPress Classic Editor,
            Gutenberg, Elementor, Divi und allen wichtigen Page-Buildern –
            überall dort, wo Sie einen benutzerdefinierten HTML-Block oder
            -Widget hinzufügen können.
          </p>
        </section>

        <section>
          <h2>Methode 2 – WordPress Virtual Tour Plugin</h2>
          <p>
            Mehrere WordPress-Plugins unterstützen das Einbetten von
            360°-Touren. Beliebte Optionen sind WP VR (für lokales Hosting
            equirektangulärer Bilder) und Virtual Tour Easy (iFrame-Manager).
            Diese Plugins fügen eine benutzerfreundliche Oberfläche zur
            Verwaltung mehrerer eingebetteter Touren auf Ihrer Website hinzu.
          </p>
          <h3>Wann ein Plugin sinnvoll ist</h3>
          <p>
            Verwenden Sie ein Plugin, wenn: Sie mehrere Touren auf vielen Seiten
            eingebettet haben und eine zentrale Verwaltung benötigen, Sie
            Tour-Bilder lieber lokal auf Ihrem Server hosten möchten statt eine
            Drittanbieter-Plattform zu nutzen, oder wenn Sie Tour-Berechtigungen
            nach Benutzerrollen verwalten müssen.
          </p>
        </section>

        <section>
          <h2>Methode 3 – Shortcode-Einbettung</h2>
          <p>
            Wenn Ihr WordPress-Theme Shortcodes in Inhaltsbereichen unterstützt,
            können Sie einen einfachen Shortcode-Wrapper erstellen: Fügen Sie
            den iFrame-Code als Shortcode-Wert in Ihrer functions.php oder über
            ein Code-Snippet-Plugin hinzu. Dies ist nützlich für
            Immobilien-Websites, auf denen Tour-Einbettungen in automatisierten
            Listing-Templates erscheinen.
          </p>
        </section>

        <section>
          <h2>Best Practices für WordPress Virtual Tour-Einbettungen</h2>
          <p>
            Stellen Sie die iFrame-Höhe auf mindestens 500 px für die
            Desktop-Ansicht ein. Verwenden Sie responsiven Wrapper-CSS für
            Mobilgeräte (die Tour sollte auf allen Geräten korrekt skalieren).
            Fügen Sie eine Fallback-Nachricht innerhalb der iFrame-Tags für
            Browser hinzu, die iFrames blockieren. Platzieren Sie die Tour
            oberhalb des Falzes auf Immobilien-Detailseiten – je höher sie
            erscheint, desto länger bleiben Besucher auf der Seite.
          </p>
        </section>
      
        <section>
          <h2>Weiterlesen</h2>
          <ul>
            <li><a href="/blog/de/360-virtual-tour-website-einbetten">360°-Virtual-Tour in Website einbetten</a></li>
            <li><a href="/blog/de/virtual-tour-seo-leitfaden">Virtual Tour SEO : Rankings verbessern</a></li>
            <li><a href="/blog/de/virtual-tour-zu-immobilienanzeige-hinzufuegen">Virtual Tour zur Immobilienanzeige hinzufügen</a></li>
            <li><a href="/blog/de/virtual-tour-kleinunternehmen">Virtual Tour Kleinunternehmen : Kunden gewinnen</a></li>
            <li><a href="/blog/de/360-virtual-tour">360° Virtual Tour : Der komplette Leitfaden</a></li>
          </ul>
        </section>

      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";

const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;

const postData = blogPostsData.find(
  (post) => post.slug === "virtual-tour-wordpress-einbetten",
);

useBlogSeo({
  title: "Virtual Tour WordPress einbetten [2026] | Travvir",
  description:
    "360°-Virtual-Tour in WordPress einbetten – Schritt-für-Schritt-Anleitung. iFrame, Plugins und Responsive-Design-Tipps.",
  slug: "virtual-tour-wordpress-einbetten",
  image: postData?.image,
  postData,
  lang: "de",
});

</script>
